import React from 'react';
import { readingTimePropTypes } from './ReadingTimePropTypes';
import Icon from '@Theme/natucare/components/Icon/Icon';
import * as styles from './ReadingTime.module.scss';
const ReadingTime = ({
  value,
  unit = 'min'
}) => {
  if (!value) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "clock",
    size: {
      width: 20,
      height: 20
    },
    classname: styles.rootIcon
  }), value, " ", unit);
};
export default ReadingTime;